export default "{{render_context}} .pdc-widget-clock .time-text {\r\n    color: <%= theme['widget-clock-text-color'] %>;\r\n}";